import { render, staticRenderFns } from "./EmailNotification.vue?vue&type=template&id=9b4d4240"
import script from "./EmailNotification.vue?vue&type=script&lang=js"
export * from "./EmailNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports